<template>
 <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro in  orderBy(registros, 'label')"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>
            <div class="info-box-content">
              <span class="info-box-text" v-if="idioma === 'DE'">{{registro.labelDe}}</span>
              <span class="info-box-text" v-else-if="idioma === 'EN'">{{registro.labelEn}}</span>
              <span class="info-box-text" v-else-if="idioma === 'ES'">{{registro.labelEs}}</span>
              <span class="info-box-text" v-else>{{registro.labelPtBr}}</span>
              <span class="info-box-number" v-if="!registro.is_bool">{{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}<small> {{registro.unidade_medida}}</small></span>
              <span class="info-box-number" v-else-if="registro.valor">On</span>
              <span class="info-box-number" v-else>Off</span>
              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
              <span class="progress-description">
                {{registro.data_atualizacao}}
              </span>
           </div>
           <!-- /.info-box-content -->
         </div>
       </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->
    <div class="row center-block" v-if="exibirGrafico">
      <div class="col-md-6" v-if="exibirGraficoG1">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGraficoG1}}</h4>
            <va-chart
                :chart-config='seteDiasGraficoG1'></va-chart>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="exibirGraficoG2">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGraficoG2}}</h4>
            <va-chart
                :chart-config='seteDiasGraficoG2'></va-chart>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="exibirGraficoG3">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGraficoG3}}</h4>
            <va-chart
                :chart-config='seteDiasGraficoG3'></va-chart>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="exibirGraficoG4">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGraficoG4}}</h4>
            <va-chart
                :chart-config='seteDiasGraficoG4'></va-chart>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="exibirGraficoG5">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGraficoG5}}</h4>
            <va-chart
                :chart-config='seteDiasGraficoG5'></va-chart>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="exibirGraficoG6">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGraficoG6}}</h4>
            <va-chart
                :chart-config='seteDiasGraficoG6'></va-chart>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
    </div>
   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>

<script>
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'
import config from '../../config'
import VAChart from '../widgets/VAChart'

var db = firebaseApp.database()

export default {
  name: 'Dashboard',
  mixins: [Vue2Filters.mixin],
  components: {
    'va-chart': VAChart
  },
  mounted () {
    if (config.exibirGraficoInicial) {
      this.efetuarPesquisa()
    }
  },
  methods: {
    efetuarPesquisa: function () {
      this.$store.dispatch('createGraficoSeteDias', config.graficoSeteDias)
      .then(response => {
        if (this.exibirGraficoG1) {
          this.seteDiasGraficoG1 = response.data.graficoG1
          this.tituloGraficoG1 = 'Gerador 1 - ' + response.data.titulo
        }
        if (this.exibirGraficoG2) {
          this.seteDiasGraficoG2 = response.data.graficoG2
          this.tituloGraficoG2 = 'Gerador 2 - ' + response.data.titulo
        }
        if (this.exibirGraficoG3) {
          this.seteDiasGraficoG3 = response.data.graficoG3
          this.tituloGraficoG3 = 'Gerador 3 - ' + response.data.titulo
        }
        if (this.exibirGraficoG4) {
          this.seteDiasGraficoG4 = response.data.graficoG4
          this.tituloGraficoG4 = 'Gerador 4 - ' + response.data.titulo
        }
        if (this.exibirGraficoG5) {
          this.seteDiasGraficoG5 = response.data.graficoG5
          this.tituloGraficoG5 = 'Gerador 5 - ' + response.data.titulo
        }
        if (this.exibirGraficoG6) {
          this.seteDiasGraficoG6 = response.data.graficoG6
          this.tituloGraficoG6 = 'Gerador 6 - ' + response.data.titulo
        }
        this.exibirGrafico = true
      })
      .catch(e => {
        console.log(e)
      })
    }
  },
  data () {
    return {
      registros: [],
      idioma: config.idioma,
      tituloGraficoG1: '',
      tituloGraficoG2: '',
      tituloGraficoG3: '',
      tituloGraficoG4: '',
      tituloGraficoG5: '',
      tituloGraficoG6: '',
      seteDiasGraficoG1: {},
      seteDiasGraficoG2: {},
      seteDiasGraficoG3: {},
      seteDiasGraficoG4: {},
      seteDiasGraficoG5: {},
      seteDiasGraficoG6: {},
      exibirGrafico: false,
      exibirGraficoG1: config.graficoSeteDias.buscarG1,
      exibirGraficoG2: config.graficoSeteDias.buscarG2,
      exibirGraficoG3: config.graficoSeteDias.buscarG3,
      exibirGraficoG4: config.graficoSeteDias.buscarG4,
      exibirGraficoG5: config.graficoSeteDias.buscarG5,
      exibirGraficoG6: config.graficoSeteDias.buscarG6
    }
  },
  firebase: {
    registros: db.ref(config.project)
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?7ca354eb